package com.eladfinish.bible.contest.screens.main.pastQuizzesSheet

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.past_quizzes_sheet_cta
import com.eladfinish.bible.contest.past_quizzes_sheet_footer
import com.eladfinish.bible.contest.past_quizzes_sheet_intro
import com.eladfinish.bible.contest.past_quizzes_sheet_point_duel_body
import com.eladfinish.bible.contest.past_quizzes_sheet_point_duel_lead
import com.eladfinish.bible.contest.past_quizzes_sheet_point_peek_body
import com.eladfinish.bible.contest.past_quizzes_sheet_point_peek_lead
import com.eladfinish.bible.contest.past_quizzes_sheet_point_practice_body
import com.eladfinish.bible.contest.past_quizzes_sheet_point_practice_lead
import com.eladfinish.bible.contest.past_quizzes_sheet_point_voice_body
import com.eladfinish.bible.contest.past_quizzes_sheet_point_voice_lead
import com.eladfinish.bible.contest.past_quizzes_sheet_tag
import com.eladfinish.bible.contest.past_quizzes_sheet_title
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureDiscoverySheet
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetContent
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetDismissMethod
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetIntro
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetPoint
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetPreviewFrame
import com.eladfinish.bible.contest.ui.components.bottomSheet.FeatureSheetTitle

/** The one-time "what's new" sheet of חידונים אמיתיים (the window and its closing are [FeatureDiscoverySheet]). */
@Composable
fun PastQuizzesSheet(
    onDismissed: (FeatureSheetDismissMethod) -> Unit,
    onCtaClicked: () -> Unit,
) {
    FeatureDiscoverySheet(onDismissed = onDismissed, onCtaClicked = onCtaClicked) { onClose, onCta ->
        PastQuizzesSheetContent(onClose = onClose, onCtaClicked = onCta)
    }
}

@Composable
fun PastQuizzesSheetContent(
    onClose: () -> Unit,
    onCtaClicked: () -> Unit,
    modifier: Modifier = Modifier,
) {
    FeatureSheetContent(
        tag = SharedRes.strings.past_quizzes_sheet_tag,
        cta = SharedRes.strings.past_quizzes_sheet_cta,
        footer = SharedRes.strings.past_quizzes_sheet_footer,
        onClose = onClose,
        onCtaClicked = onCtaClicked,
        modifier = modifier,
    ) {
        FeatureSheetTitle(SharedRes.strings.past_quizzes_sheet_title)
        FeatureSheetIntro(SharedRes.strings.past_quizzes_sheet_intro)
        FeatureSheetPoint(
            lead = SharedRes.strings.past_quizzes_sheet_point_peek_lead,
            body = SharedRes.strings.past_quizzes_sheet_point_peek_body,
        )
        FeatureSheetPoint(
            lead = SharedRes.strings.past_quizzes_sheet_point_practice_lead,
            body = SharedRes.strings.past_quizzes_sheet_point_practice_body,
        )
        FeatureSheetPoint(
            lead = SharedRes.strings.past_quizzes_sheet_point_voice_lead,
            body = SharedRes.strings.past_quizzes_sheet_point_voice_body,
        )
        FeatureSheetPoint(
            lead = SharedRes.strings.past_quizzes_sheet_point_duel_lead,
            body = SharedRes.strings.past_quizzes_sheet_point_duel_body,
        )
    }
}

@Preview(showBackground = true, widthDp = 390, heightDp = 844, name = "Sheet — phone")
@Composable
private fun PastQuizzesSheetContentPreview() {
    FeatureSheetPreviewFrame {
        PastQuizzesSheetContent(onClose = {}, onCtaClicked = {})
    }
}

/** iPhone SE height: the text scrolls, the button stays on screen. */
@Preview(showBackground = true, widthDp = 320, heightDp = 480, name = "Sheet — small screen")
@Composable
private fun PastQuizzesSheetContentSmallPreview() {
    FeatureSheetPreviewFrame {
        PastQuizzesSheetContent(onClose = {}, onCtaClicked = {})
    }
}
